import { PaginableResult, PaginationData } from "@/app/types";
import { AddressType } from "@/app/types/address";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type PaymentType = "portal" | "c2c" | "cash";

type AddressState = {
	get_in_process: boolean;
	create_in_process: boolean;
	update_in_process: boolean;
	delete_in_process: boolean;
	addresses: AddressType[];
	pagination: PaginationData | null;
};

const initialState: AddressState = {
	addresses: [],
	pagination: null,

	get_in_process: false,
	create_in_process: false,
	update_in_process: false,
	delete_in_process: false,
};

const addressSlice = createSlice({
	name: "address",
	initialState,

	reducers: {
		getAddressStarted: (state) => {
			state.get_in_process = true;
			state.addresses = [];
		},
		getAddressSuccess: (state, action: PayloadAction<PaginableResult<AddressType[]>>) => {
			state.get_in_process = false;
			state.addresses = [...action.payload.data];
			if (action.payload.pagination) {
				state.pagination = { ...action.payload.pagination };
			}
		},
		getAddressFailed: (state) => {
			state.get_in_process = false;
		},

		createAddressStarted(state) {
			state.create_in_process = true;
		},
		createAddressSuccess(state) {
			state.create_in_process = false;
		},
		createAddressFailed(state) {
			state.create_in_process = false;
		},

		updateAddressStarted(state) {
			state.update_in_process = true;
		},
		updateAddressSuccess(state, action: PayloadAction<AddressType>) {
			state.addresses = state.addresses.map((item) => {
				if (item.id === action.payload.id) {
					return { ...action.payload };
				}
				return item;
			});
			state.update_in_process = false;
		},
		updateAddressFailed(state) {
			state.update_in_process = false;
		},

		deleteAddressStarted(state) {
			state.delete_in_process = true;
		},
		deleteAddressSuccess(state, action: PayloadAction<{ id: number }>) {
			state.delete_in_process = false;
			state.addresses = state.addresses.filter((ad) => ad.id !== action.payload.id);
		},
		deleteAddressFailed(state) {
			state.delete_in_process = false;
		},
		emptyAddressList(state) {
			state.get_in_process = true;
			state.addresses = [];
		},
	},
});

export default addressSlice;
